import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';

import { CommonService } from '../services/common.service';
import { ApiService } from '../services/api.service';
import { Location, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';

import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';

import { MomentDateTimeAdapter } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import * as moment from "moment";
import { TranslationService } from '../services/translation.service';
import { IonInput } from '@ionic/angular';



export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY HH:mm',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
  ],
})
export class ProfilePage implements OnInit {
  @ViewChild('passwordForm', { static: false }) passwordForm: any;
  @ViewChild('focusconfirmPassword') focusconfirmPassword;

  profileForm: FormGroup;
  userId: string;
  user: any = {};
  tempuser: any = {}
  submitted = false;
  showPage: boolean = false;
  showConfirmPassword: boolean = false;

  show2FA: boolean = false;
  qrString:any;
  showQRcode:boolean =false;

  controlStatus: any = {
    PhoneNumber: false,
    Mobile: false,
    Email: false,
    NewPassword: false,
    NewPassword2: false,
    otpCode: false
  };

  disableSave: boolean;
  showApproveEmail: boolean = true;
  locale: any;
  tempLocale: any;



  allLocales: any = [];
  public max = new Date(moment().format());
  isSSO: boolean = false;

  constructor(private formBuilder: FormBuilder,private _translationService: TranslationService, private el: ElementRef, private dateTimeAdapter: DateTimeAdapter<any>, private datePipe: DatePipe, private _apiService: ApiService, public _commonService: CommonService, private location: Location, private router: Router, public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {

    this.profileForm = this.formBuilder.group({
      FirstName: ['', Validators.required],
      MiddleName: [''],
      Initials: [''],
      Gender: [''],
      Role: [''],
      LastName: ['', Validators.required],
      Birthdate: [''],
      PhoneNumber: ['', [Validators.pattern(this._commonService.phonePattern)]],
      Mobile: ['', [Validators.pattern(this._commonService.phonePattern)]],
      Enable2FactorAuthentication: [true],
      Email: ['', [Validators.required, Validators.email]],
      Company: [''],
      Position: [''],
      EnableApprovalEmail: [''],
      Department: [''],
      otpCode:['', [Validators.pattern(this._commonService.otpCodePattern)]],
      Infix: [''],
      // Password: [''],
      NewPassword: ['', [Validators.required,Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]],
      NewPassword2: ['', [Validators.required,Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]],
      // CurrentPassword: ['',[Validators.required, Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]],
      Description: [''],
      DefaultLocale: [this._commonService.locale ? this._commonService.locale : 1043],
      Newspaper:[false]
    },
    {
      validator: this.MatchPassword // Inject the provider method
    });
  }

  get f() { return this.profileForm.controls; }

  ionViewWillEnter(){
    if(localStorage.isSSO && localStorage.isSSO == 'true' ) {
      this.isSSO = true;
    }
  }

  ionViewDidEnter() {
    if(localStorage.Force2FactorAuthentication == 'True'){
      this.show2FA = true
    }
    this.getLocales();
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    if(this.locale == '1043'){
      this.dateTimeAdapter.setLocale('nl');
    }else {
      this.dateTimeAdapter.setLocale('en');
    }
    this.showApproveEmail = false;
    this.userId = localStorage.userId;
    if (!this.userId) {
      this.location.back();
    }
    else{
      this.getUserDetails();
    }

  }
  async getUserDetails() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getUserProfile(this.userId);
      this.user = res.body;
      this.tempuser = res.body
      this.qrString = 'otpauth://totp/' + this.user.EmailAddress + '?secret=' + res.body.SecretKey + '&issuer=brandmr'
      this._commonService.log(this.user, this._commonService.LOG);
      this.profileForm.patchValue({
        FirstName: this.user.FirstName,
        MiddleName: this.user.MiddleName,
        Gender: this.user.Gender,
        Enable2FactorAuthentication: Number(this.user.Enable2FactorAuthentication) ? true : false,
        EnableApprovalEmail: Number(this.user.EnableApprovalEmail) ? true : false,
        Role: this.user.RoleName ? this.user.RoleName : null,
        Initials: this.user.Initials,
        LastName: this.user.LastName,
        Infix: this.user.Infix,
        // Birthdate: this.user.Birthdate? this.datePipe.transform(new Date(this.user.Birthdate), "dd-MM-yyyy"): null,
        PhoneNumber: this.user.PhoneNumber,
        Company: this.user.CompanyName  ? this.user.CompanyName  : null,
        Mobile: this.user.MobileNumber,
        Email: this.user.EmailAddress,
        Position: this.user.Function,
        Department: this.user.Department,
        Description: this.user.Description,
        DefaultLocale: this.user.DefaultLocale ? this.user.DefaultLocale : this._commonService.locale,
        NewPassword: "********",
        NewPassword2: "********",
        Newspaper: Number(this.user.Newspaper) ? true : false,

      });
      const passwordControl = this.profileForm.get('NewPassword');
      passwordControl.clearValidators();
      passwordControl.setErrors(null);
      if (this.user.RoleId === 'fe0380d2-aea5-4c20-95a6-5882712eaf84' || this.user.RoleId === 'a268d471-b525-42f2-a6e6-73ec4073f3fb'){
        this.showApproveEmail = true;
      }else{
        this.showApproveEmail = false;
      }
      this.showPage = true;
      this._commonService.dismiss();
      this.profileForm.updateValueAndValidity();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        this.allLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.allLocales.length; i++) {
          if (this.allLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.allLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.allLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.allLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }

      } else {
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.allLocales = localeData.body;
        localStorage.domainLocales = JSON.stringify(localeData.body);
        for (let i = 0; i < this.allLocales.length; i++) {
          if (this.allLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.allLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.allLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.allLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  onLocaleChanged() {
    this.locale = this.profileForm.controls["DefaultLocale"].value;
    if(this.locale == '1043'){
      this.dateTimeAdapter.setLocale('nl');
    }else {
      this.dateTimeAdapter.setLocale('en');
    }
  }

  enable2FA(event){
    if(event.detail.checked == true){
        this.showQRcode = true;

        const otpCodeControl = this.profileForm.get('otpCode');
        otpCodeControl.setValidators([Validators.required, Validators.pattern(this._commonService.otpCodePattern)])
        this.profileForm.updateValueAndValidity()
    }else{
      this.showQRcode = false;
      this.disableSave = false
      this.controlStatus.otpCode = false
      const otpCodeControl = this.profileForm.get('otpCode');
      otpCodeControl.clearValidators();
      otpCodeControl.setErrors(null)
      this.profileForm.updateValueAndValidity()
      this.profileForm.patchValue(
        {
          otpCode:null
        }
      )


    }
  }

  cancelConfirmPasswordModal() {
      this.passwordForm.form.reset();
      this.passwordForm.submitted = false;
    setTimeout(() => {
      this.ngxSmartModalService.getModal('confirmProfilePassword').close();
      this.showConfirmPassword = false;
    }, 5)
  }

  setPasswordValidation(event){
    if(this.profileForm.get('NewPassword').value != '********' && this.profileForm.get('NewPassword').value != ''){

      const passwordControl = this.profileForm.get('NewPassword');
      passwordControl.setValidators(Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/));
      passwordControl.updateValueAndValidity()
    }else{
      const passwordControl = this.profileForm.get('NewPassword');
      passwordControl.setErrors(null);
    }
  }

  onBlurMethod(controlName){
    if(controlName == 'PhoneNumber'){
      this.controlStatus.PhoneNumber = true
    }
    if(controlName == 'Mobile'){
     this.controlStatus.Mobile = true
   }
   if(controlName == 'Email'){
    this.controlStatus.Email = true
  }
  if(controlName == 'otpCode'){
    this.controlStatus.otpCode = true
  }

  if(controlName == 'NewPassword'){
    if(this.profileForm.get('NewPassword').value != '********' && this.profileForm.get('NewPassword').value != ''){

      const passwordControl = this.profileForm.get('NewPassword');
      passwordControl.setValidators(Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/));
      passwordControl.updateValueAndValidity()
    }else{
      console.log("value != ")
    }
    this.controlStatus.NewPassword = true

  }
  if(controlName == 'NewPassword2'){
    this.controlStatus.NewPassword2 = true
  }
   }

   onFocusMethod(controlName){
    if(controlName == 'PhoneNumber'){
      this.controlStatus.PhoneNumber = false
    }
    if(controlName == 'Mobile'){
     this.controlStatus.Mobile = false
   }
   if(controlName == 'Email'){
    this.controlStatus.Email = false
  }
  if(controlName == 'otpCode'){
    this.controlStatus.otpCode = false
  }

  if(controlName == 'NewPassword'){
    this.controlStatus.NewPassword = false
  }
  if(controlName == 'NewPassword2'){
    this.controlStatus.NewPassword2 = false
  }
   }

  async saveUserDetails(form){
  if(!this.isSSO){
    this.ngxSmartModalService.getModal('confirmProfilePassword').close();
  }

  this.showConfirmPassword = false;
    this._commonService.presentLoading();

    try {
      let data = {
        UserId: this.user.UserId,
        RoleId: this.user.RoleId,
        Status: this.user.Status,
        DomainId: localStorage.domainId || null,
        Enable2FactorAuthentication: this.profileForm.value.Enable2FactorAuthentication ? '1' : '0',
        EnableApprovalEmail: this.profileForm.value.EnableApprovalEmail ? '1' : '0',
        Initials: this.profileForm.value.Initials || null,
        FirstName: this.profileForm.value.FirstName || null,
        MiddleName: this.profileForm.value.MiddleName || null,
        Gender: this.profileForm.value.Gender || null,
        LastName: this.profileForm.value.LastName || null,
        PhoneNumber: this.profileForm.value.PhoneNumber || null,
        MobileNumber: this.profileForm.value.Mobile || null,
        EmailAddress: this.profileForm.value.Email || null,
        Infix: this.profileForm.value.Infix || null,
        Birthdate: this.user.Birthdate? this.datePipe.transform(new Date(this.user.Birthdate), "yyyy-MM-dd"): null,
        Password: this.profileForm.value.NewPassword === "" ? null : this.profileForm.value.NewPassword,
        Function: this.profileForm.value.Position || null,
        Department: this.profileForm.value.Department || null,
        Description: this.profileForm.value.Description || null,
        ObjectGroups: null,
        CompanyId: this.user.CompanyId,
        DefaultLocale: this.profileForm.value.DefaultLocale ? this.profileForm.value.DefaultLocale  : 1043,
        Newspaper: this.profileForm.value.Newspaper ? '1' : '0',
      }
      // let userObjectGroups = [];
      // this.user.ObjectGroups.forEach(item => {
      //   if (item.ObjectGroupId) {
      //     userObjectGroups.push(item.ObjectGroupId);
      //   }
      // });
      // data.ObjectGroups = userObjectGroups;
      if (this.user.UserId) {
        if (data.Password == "********" || data.Password == "") {
          // data.Password = null;
          delete data.Password
        }
        this._commonService.log(data, this._commonService.LOG);

        await this._apiService.putUserProfile(data, this.isSSO?'':form.value.UserPassword);
        // const CurrentPasswordControl = this.profileForm.get('CurrentPassword')
        // this.profileForm.controls['NewPassword'].reset();
        //   this.profileForm.controls['NewPassword2'].reset();
          // this.profileForm.controls['CurrentPassword'].reset();
          // CurrentPasswordControl.clearValidators();
          // CurrentPasswordControl.setErrors(null);
          // CurrentPasswordControl.updateValueAndValidity();


        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
       localStorage.locale = this.profileForm.value.DefaultLocale
       this._translationService.getTranslation(this.locale);
       let menu = await this._apiService.getMenuItems('');
      localStorage.setItem('menuItems', JSON.stringify(menu.body));
      this._commonService.menuItems = menu.body;
      this._commonService.formatMenuItems();
      this._commonService.dismiss();
      let localeData = await this._apiService.getDomainLocales('', 1, 0);
       this.allLocales  = localeData.body;
      localStorage.domainLocales = JSON.stringify(localeData.body);
      for (let i = 0; i < this.allLocales.length; i++) {
        if (this.allLocales[i].LocaleIconUrl == 'flag-icon-nl') {
          this.allLocales[i].Icon = 'assets/flags/1x1/nl.svg'
        }
        if (this.allLocales[i].LocaleIconUrl == 'flag-icon-gb') {
          this.allLocales[i].Icon = 'assets/flags/1x1/gb.svg'
        }
      }
        this.submitted = false;
        this.profileForm.patchValue({
          otpCode:''
        })

      }
    }
    catch (error) {
      this.submitted = false;
      if(error.status >= 500 && error.status < 600){
        this.profileForm.patchValue({
          FirstName: this.tempuser.FirstName,
          MiddleName: this.tempuser.MiddleName,
          Gender: this.tempuser.Gender,
          Enable2FactorAuthentication: Number(this.tempuser.Enable2FactorAuthentication) ? true : false,
          EnableApprovalEmail: Number(this.tempuser.EnableApprovalEmail) ? true : false,
          Role: this.tempuser.RoleName ? this.tempuser.RoleName : null,
          Initials: this.tempuser.Initials,
          LastName: this.tempuser.LastName,
           Birthdate: this.user.Birthdate? this.datePipe.transform(new Date(this.user.Birthdate), "dd-MM-yyyy"): null,
          PhoneNumber: this.tempuser.PhoneNumber,
          Company: this.tempuser.CompanyName  ? this.tempuser.CompanyName  : null,
          Mobile: this.tempuser.MobileNumber,
          Email: this.tempuser.EmailAddress,
          Position: this.tempuser.Function,
          Infix: this.tempuser.Infix,
          Department: this.tempuser.Department,
          Description: this.tempuser.Description,
          DefaultLocale: this.tempuser.DefaultLocale ? this.tempuser.DefaultLocale : this._commonService.locale,
          NewPassword: "********",
          NewPassword2: "********",
          otpCode:null,
          Newspaper: Number(this.tempuser.Newspaper) ? true : false,

        });

      }
      this._commonService.log(error, this._commonService.ERROR);

        this._commonService.dismiss();
    }
  }

  async onSubmit() {
    this.submitted = true;
    if(this.user.Birthdate){
      this.profileForm.patchValue({
            BirthDate: this.datePipe.transform(new Date(this.user.Birthdate), "dd-MM-yyyy"),
      })
    }
    // if(!this.user.Birthdate){
    //   const birthdate = this.profileForm.get('Birthdate');
    //   birthdate.setValidators([Validators.required]);
    //   birthdate.updateValueAndValidity();
    // }
    if(this.isSSO){
      const password = this.profileForm.get('NewPassword');
      const confirmPassword = this.profileForm.get('NewPassword2');
      password.setErrors(null);
      confirmPassword.setErrors(null);
    }

    if (this.profileForm.invalid) {
      this.controlStatus.PhoneNumber = true,
      this.controlStatus.Mobile = true,
      this.controlStatus.Email = true,
      this.controlStatus.NewPassword = true,
      this.controlStatus.NewPassword2 = true,
      this.controlStatus.otpCode = true

     setTimeout(() => {

        const firstInvalidControl = this.el.nativeElement.querySelector(
          ".is-invalid"
        );
        firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });;
      }, 0);
      // if(!firstInvalidControl && this.profileForm.controls.Birthdate.value == "") {
      //   firstInvalidControl = document.querySelector('input.ng-valid');
      // }

      return;
    }else{
      if(!this.isSSO){
        this.showConfirmPassword = true;
        setTimeout(() => {
          this.ngxSmartModalService.getModalStack().forEach(element => {
            if (element.id === 'confirmProfilePassword') {
              this.ngxSmartModalService.getModal('confirmProfilePassword').open();
            }
          });
        }, 0)
        setTimeout(() => {
          this.focusconfirmPassword.setFocus();
        }, 200);
      }else{
        this.saveUserDetails(this.profileForm)
      }

    }
  }

  onReset() {
    this.submitted = false;
    this.disableSave = false
    this.profileForm.reset();
  }

  ionViewDidLeave() {
    this.showApproveEmail = false
    this.onReset()
  }

  private MatchPassword(abstractControl: AbstractControl) {
    const Password = abstractControl.get('NewPassword').value // to get value in input tag
    const ConfirmPassword = abstractControl.get('NewPassword2').value // to get value in input tag
    if (Password == "") {
      abstractControl.get('NewPassword').setErrors({required: true});
    } else if (ConfirmPassword == "") {
      abstractControl.get('NewPassword2').setErrors({required: true});
    }

    if (Password != ConfirmPassword && ConfirmPassword != "") {
      abstractControl.get('NewPassword2').setErrors({ MatchPassword: true });
    } else if(ConfirmPassword != "") {
      abstractControl.get('NewPassword2').setErrors(null);
    }
  }


  resetDate() {
    this.user.Birthdate = "";
    this.profileForm.patchValue({
      Birthdate: null
    })
  }
  goBack() {
    this.location.back();
  }
delete(){

}
  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
          this.onSubmit();
          break;
      case "delete":
          this.delete();
          break;
      case "backToList":
          this.goBack();
          break;
      case "backToMain":
          this.router.navigate(['maintenance'], { replaceUrl: true })
          break;
      case "back":
          this.goBack();
          break;
      }

  }
// //testtrrrssss
//   setPasswordValidation() {
//     const newPasswordControl = this.profileForm.get('NewPassword');
//     const newPassword2Control = this.profileForm.get('NewPassword2');
//     let newPassword = this.profileForm.controls["NewPassword"].value;
//     let newPassword2 = this.profileForm.controls["NewPassword2"].value;

//     if (this.showPage) {
//       this.submitted = false;
//       if ((newPassword != "********") && (newPassword != "")) {
//         newPasswordControl.setValidators([Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]);
//         newPasswordControl.markAsDirty();
//         newPasswordControl.updateValueAndValidity();
//         if (newPassword2 == ""){
//           newPassword2Control.clearValidators();
//           newPassword2Control.setErrors(null);
//           newPassword2Control.updateValueAndValidity();
//         }
//       } else {
//         newPasswordControl.clearValidators();
//         newPasswordControl.setErrors(null);
//         newPasswordControl.updateValueAndValidity();
//         newPassword2Control.clearValidators();
//         newPassword2Control.setErrors(null);
//         newPassword2Control.updateValueAndValidity();
//       }

//       if ((newPassword2 != "********")) {
//         if ((newPassword != "********") && (newPassword != "") && (newPassword2 != newPassword)){
//           if (newPassword != ""){
//            newPassword2Control.setValidators([Validators.required]);
//            newPassword2Control.updateValueAndValidity();
//           }else{
//             newPassword2Control.clearValidators();
//             newPassword2Control.setErrors(null);
//           }
//         }else{
//           newPassword2Control.clearValidators();
//           newPassword2Control.setErrors(null);
//         }
//       }
//     }
//   }
  onFullFill(event){
    this.profileForm.patchValue({
      otpCode:event
    })
    this.onSubmit();
  }

  async onInputChange(event){
    if(this.profileForm.value.otpCode != '' && this.profileForm.value.otpCode.length == 6){

      try {
        this._commonService.presentLoading();
        let data = {
          otpCode: this.profileForm.value.otpCode
        }
        let res = await this._apiService.verifyOtpCode(data)
        if(res){
          this.disableSave = false
        }
        this._commonService.dismiss()

      } catch (error) {
        this._commonService.dismiss()
        this.disableSave = true

      }

      //this.onSubmit()
    }

   }

  BirthDateTimeChange(event) {
    this.profileForm.patchValue({
      Birthdate: this.datePipe.transform(new Date(event.value), "dd-MM-yyyy"),
    })
  }

}
